module.exports = __webpack_public_path__ + "static/persona_icon.62736751.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/persona_icon.png
// module id = 435
// module chunks = 35783957827783